module.exports = __webpack_public_path__ + "static/media/PG.779acb73.svg";